import $ from "jquery";

const JobSlider = function (breakPoint) {
  const $sliderElement = $("#js-jobSlider");
  const $buttonSliderElement = $("#js-jobButtonSlider");
  $sliderElement.hide();
  $buttonSliderElement.hide();
  $(window).on("load", function () {
    $sliderElement.show();
    $buttonSliderElement.show();

    class Slider {
      constructor($sliderElement, $buttonSliderElement) {
        this.$slider = $sliderElement;
        this.$buttonSlider = $buttonSliderElement;
        this.$prev = $("#js-jobSliderPrev");
        this.$next = $("#js-jobSliderNext");
        this.$buttons = $(".js-jobSliderButton");
        this.index = 0;
        this.handler();
      }
      // ハンドラー
      handler() {
        this.getSlideIndex();
        this.setSlickSlider();
        this.setButtonSlickSlider();
        this.addEventClick();
      }
      // ナビゲーションクリック時のハンドラ
      addEventClick() {
        const self = this;
        // ナビゲーションのインデックスに応じてスライド
        this.$buttons.on("click", function (event) {
          const index = event.currentTarget.dataset.slickIndex;
          self.gotoSlide(index);
        });
        // 前へ
        this.$prev.on("click", function () {
          self.$slider.slick("slickPrev");
        });
        // 次へ
        this.$next.on("click", function () {
          self.$slider.slick("slickNext");
        });
      }
      // ナビゲーションのインデックスに応じてスライド
      gotoSlide(index) {
        this.$slider.slick("slickGoTo", index);
      }
      // 現在のインデックスを取得
      getSlideIndex() {
        const self = this;
        self.$slider.on(
          "init reInit beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            self.index = nextSlide ? nextSlide : 0;
            self.$buttons.removeClass("is-current");
            $(`.js-jobSliderButton[data-slick-index="${self.index}"]`).addClass('is-current');
          }
        );
      }
      // Slick
      setSlickSlider() {
        this.$slider.slick({
          autoplay: false,
          arrows: false,
          dots: false,
          variableWidth: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          lazyLoad: "progressive",
          responsive: [
            {
              breakpoint: breakPoint,
              settings: {
                asNavFor: this.$buttonSlider,
              }
            }
          ]
        });
      }
      setButtonSlickSlider() {
        this.$buttonSlider.slick({
          autoplay: false,
          arrows: false,
          dots: false,
          variableWidth: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          lazyLoad: "progressive",
          responsive: [
            {
              breakpoint: breakPoint,
              settings: {
                asNavFor: this.$slider,
                dots: true,
              }
            }
          ]
        });
      }
    }
    // インスタンス化
    new Slider($sliderElement, $buttonSliderElement);
  });
};

export default JobSlider;



// WEBPACK FOOTER //
// ./src/recruit/js/jobSlider.js